import React from 'react';
import { getProductMode } from '../backend/productMode';

/**
 * SetupModuleStub (unified-viewer-setup-design.md §4.6) — the placeholder the registry
 * resolves for any module scaffolded but not yet implemented for the active product mode.
 * Keeps the shell/nav complete for every mode so future work is fill-in-the-stub.
 */
const SetupModuleStub = ({ id, label, hint }) => {
  const mode = String(getProductMode() || 'local').toLowerCase();
  return (
    <div style={styles.wrap}>
      <div style={styles.title}>{label || id}</div>
      <div style={styles.panel}>
        <div style={styles.badge}>Not yet implemented — {mode}</div>
        {hint ? <div style={styles.hint}>{hint}</div> : null}
      </div>
    </div>
  );
};

export default SetupModuleStub;

const styles = {
  wrap: { padding: '10px 4px', color: 'white' },
  title: { fontSize: 20, fontWeight: 'bold', marginBottom: 16 },
  panel: {
    display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
    minHeight: 220, border: '1px dashed #555', borderRadius: 8,
    backgroundColor: 'rgba(255,255,255,0.02)',
  },
  badge: { color: '#9aa4b2', fontSize: 15, fontStyle: 'italic' },
  hint: { color: '#6b7280', fontSize: 13, marginTop: 10, maxWidth: 460, textAlign: 'center' },
};
